// extracted by mini-css-extract-plugin
module.exports = {"label":"DownloadCsvEncodingRadioButton__label--29QDm","note":"DownloadCsvEncodingRadioButton__note--2KrBb"};